export const PLATFORM_USER = { id: 'platform', name: 'Self+', image: '/images/selfplus_logo.svg' } as const;
Object.freeze(PLATFORM_USER);
